module.exports = __webpack_public_path__ + "img/PLAIN.368be9d3.png";